import { useEffect, useCallback } from "react";
import { useMatch, useParams } from "react-router";

import { SiteItem } from "@vviinn/user-managment-client-ts";

import {
  useAppDispatch,
  useAppSelector,
  changeActiveSite,
  resetSelectedSite,
} from "../../store";

type SiteId = SiteItem["id"] | undefined;

export const useSites = () => {
  const { siteId } = useParams();
  const dispatch = useAppDispatch();
  const isRootRoute = useMatch("/");

  const sites = useAppSelector((state) => state.sites.sites);
  const selectedSiteId = useAppSelector((state) => state.site?.id);

  const getInitialSiteId = useCallback((): SiteId => {
    return parseSiteId(siteId) ?? selectedSiteId ?? sites[0]?.id;
  }, [isRootRoute]);

  const getSite = useCallback(
    (siteId: SiteId) => sites.find((s) => s.id === siteId),
    [siteId, sites],
  );
  const parseSiteId = useCallback(
    (siteId: string | undefined) => (siteId ? parseInt(siteId) : undefined),
    [siteId],
  );

  useEffect(() => {
    if (!sites) return;

    const initialSiteId = getInitialSiteId();
    const currentSiteId = parseSiteId(siteId);

    let targetSite = getSite(currentSiteId) ?? getSite(initialSiteId);
    const site = targetSite ?? sites[0];

    if (site) {
      dispatch(changeActiveSite(site));
    } else {
      dispatch(resetSelectedSite());
    }
  }, [sites]);
};
